import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import router from './router';
import App from './App.vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

// Fogli di stile dell'app, in ordine di crescente specificita' di intento:
// prima le utility, poi il tema di Element, poi il nostro globale, infine il
// layout condiviso dei form (vedi la nota in forms.css).
import './styles/tailwind.css';
import './styles/element-overrides.css';
import './styles/global.css';
import './styles/forms.css';

const pinia = createPinia();
const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
app.component('VueDatePicker', VueDatePicker)
app.use(ElementPlus);
app.use(pinia);
app.use(router);
app.mount('#app');
